export default __webpack_public_path__ + "static/media/dixsept.d1358822.jpg";